import React, { useCallback, useEffect, useState } from "react";
import api from "../services/api";
import axios, { Canceler } from "axios";
import SCAutoComplete from "./form/autocomplete/SCAutoComplete";
import { useAuth } from "../providers/auth";

let cancel: Canceler;

type Props = any;

const SelectFonte: React.FC<Props> = ({
  name,
  control,
  errors,
  label,
  loading,
  minLength = 3,
  ...props
}) => {
  const [lista, setLista] = useState<any>([]);
  const { periodoSelecionado, usuario } = useAuth();

  useEffect(() => {
    const load = async () => {
      const response = await api.get("/fontes/fonteAtivas", {
        params: {
          EmpresaId: periodoSelecionado?.EmpresaId,
        },
      });
      setLista(response.data);
    };

    load();
  }, []);

  const search = async (event: any): Promise<void> => {
    if (cancel !== undefined) {
      cancel("Operação cancelada pelo usuário");
    }

    const response = await api.get("/fontes/fonteAtivas", {
      params: {
        EmpresaId: periodoSelecionado?.EmpresaId,
      },
      cancelToken: new axios.CancelToken((c) => (cancel = c)),
    });
    setLista(response.data);
  };

  return (
    <SCAutoComplete
      loading={loading}
      name={name}
      label={label}
      control={control}
      errors={errors}
      suggestions={lista}
      completeMethod={search}
      field={"Codigo"}
      dropdown
      {...props}
    />
  );
};

export default SelectFonte;
